import React, { FC, useLayoutEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import { CenteredSpinner } from 'src/shared/components/CenteredSpinner';

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

interface PdfDocumentProps {
    file: string;
}

export const PdfDocument: FC<PdfDocumentProps> = ({ file }) => {
    const contentRef = useRef<HTMLDivElement | null>(null);
    const [pageNum, setPageNum] = useState<number | null>(null);
    const [width, setWidth] = useState<number | null>(null);

    useLayoutEffect(() => {
        if (contentRef.current) {
            setWidth(contentRef.current.offsetWidth);
        }
    }, []);

    return (
        <div ref={contentRef}>
            <Document
                file={file}
                onLoadSuccess={({ numPages }) => {
                    setPageNum(numPages);
                }}
                loading={<CenteredSpinner />}
            >
                {pageNum &&
                    new Array(pageNum)
                        .fill(0)
                        .map((_, index) => (
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                width={width}
                                loading=""
                            />
                        ))}
            </Document>
        </div>
    );
};
